module.exports = __webpack_public_path__ + "static/media/blueprism.b9c199b6.png";